import { Component, AfterViewInit, OnInit } from '@angular/core';
import { SharedService } from '../service/shared.service';
import { FormBuilder, FormGroup, Validators } from '@angular/forms';
import { Router } from '@angular/router';
import { ApiServiceService } from '../service/api-service.service';
import {  NavigationEnd } from '@angular/router';
import { configuration } from 'src/configuration';

declare var $: any;

@Component({
  selector: 'app-footer',
  templateUrl: './footer.component.html',
  styleUrls : ['./footer.component.css']
})
export class FooterComponent implements OnInit {
  showSection: boolean = false;
   cityData: any = []
   cityCountRecords: any[] = []; // Stores the list of all popular cities/localities (for tabs)
  landmarkCountRecords: any[] = []; // Sub-localities/landmarks for the selected city
   isMyProperty: any;
    developerData: any[] = [];
    reviewData: any[] = [];
   searchCityId: any = '';
   searchTerm: any = '';
  showOptions: boolean = false;
   tempCityData: any = []
  // === Search/Filter State ===
  searchWhereActual: any = { 
    city: null, // Holds the selected city NAME (e.g., 'Ambi')
    city_id: null, // Holds the selected city ID
    landmark: null,
    property_type_id: null,
  };
   propertyList: any = [];
  limit: any = configuration.PAGE_LIMIT;
  offset: any = configuration.OFFSET;

  zoom: number = 8;
  lat: number = 51.673858;
  lng: number = 7.815982;
  helpusImprove: FormGroup;
 
  markers = [
      {
          lat: 51.673858,
          lng: 7.815982,
          label: "A",
          draggable: true
      },
      {
          lat: 51.373858,
          lng: 7.215982,
          label: "B",
          draggable: false
      },
      {
          lat: 51.723858,
          lng: 7.895982,
          label: "C",
          draggable: true
      }
  ];
  is_cookie_status:any = "";
  
  constructor(
    public shared: SharedService,
    private fb: FormBuilder,
    private router: Router,
    private apiService: ApiServiceService
  ) {
    this.helpusImprove = this.fb.group({
      name: ['', Validators.required],
      mobile: ['', Validators.required],
      email: ['', Validators.required],
      feedback: ['', Validators.required],
    });
    if(this.shared.isBrowser()) {
      this.is_cookie_status = localStorage.getItem("is_cookie_status") ?  localStorage.getItem("is_cookie_status") : "";
    }
    this.router.events.subscribe((event) => {
      if (event instanceof NavigationEnd) {
        this.showSection = this.router.url === '/'; 
      }
    });
  }
  ngOnInit(): void {
     this.getPropertyList();
    this.getCityList();
    this.getData();
    this.getCityListAndInitialize();
  }

  clickedMarker(label: string, index: number) {
    console.log(`clicked the marker: ${label || index}`)
  }


  onClear() {
    console.log(this.helpusImprove.value);
    // Handle document assistant form clearing logic here
  }

  agree() {
    this.is_cookie_status = "1";
    localStorage.setItem("is_cookie_status", "1");
  }
   getCityUrl(city: string): string {
    return 'properties/city/' + city.split(' ').join('%20');
  }

  onHelpImprove() {
    setTimeout(() => {
      $('#exampleModalHelpUs').modal('show');
    });
  }

  closeHelpImprove() {
    setTimeout(() => {
      $('#exampleModalHelpUs').modal('hide');
    });
  }
   async getPropertyList() {
      if (!this.searchWhereActual.city_id) {
          // Stop if no city is selected
          return; 
      }
      
      this.shared.isLoader = true;
      // Clear propertyList as we only want to show landmarks
      this.propertyList = [];
      this.landmarkCountRecords = [];
  
      // Prepare the JSON payload, primarily for the landmark fetch
      let json: any = { ...this.searchWhereActual };
      json.city_id = this.searchWhereActual.city_id; 
      
      // --- 1. Fetch the Landmarks/Sub-localities for the Selected City ---
      if (!this.isMyProperty) {
         if (this.searchWhereActual.city) {
         let res = await this.apiService.POST_apiRequest(configuration.ENDPOINT.PROPERTY_LIST_COUNT_LANDMARK, json);
          if (res && !res.error && res.data) {
            this.landmarkCountRecords = res.data;
          }
        } else {
          let res = await this.apiService.POST_apiRequest(configuration.ENDPOINT.PROPERTY_LIST_COUNT_CITY, json);
          if (res && !res.error && res.data) {
            this.cityCountRecords = res.data;
          }
        }
      }
  
      // NOTE: The main PROPERTY_LIST API call is omitted here 
      // since you only want to display landmarks.
      
      this.shared.isLoader = false;
     
  }
     async getCityListAndInitialize() {
    
      // Call your existing city list function
      await this.getCityList(); 
  
      // After cities are fetched, initialize the UI
      if (this.cityData.length > 0) {
        // Automatically select the first city
        const firstCity = this.cityData[0];
        
        this.searchWhereActual.city = firstCity.city_name;
        this.searchWhereActual.city_id = firstCity.id;
        
        // Load the data for the default city
        this.getPropertyList();
      } else {
          this.shared.isLoader = false;
          
      }
    }
  
    async getCityList(){
      let res = await this.apiService.GET_apiRequest(configuration.ENDPOINT.CITY_LIST);
      if(res && !res.error && res.data && res.data.rows){
        this.tempCityData = res.data.rows
        this.cityData = res.data.rows // This array will populate the tabs
      }
    }
    
    // Handle the click on a city tab
    selectCity(city: any): void {
      const cityName = city.city_name;
      const cityId = city.id;
  
      if (this.searchWhereActual.city === cityName) return;
  
      // 1. Update the selected city details
      this.searchWhereActual.city = cityName;
      this.searchWhereActual.city_id = cityId;
      this.searchWhereActual.landmark = null;
      
      // 2. Reset and fetch data for the new city
      this.offset = 0;
      this.propertyList = [];
      this.landmarkCountRecords = [];
      
      this.getPropertyList();
    }
  
  
    onInputChange(event: any) {
      const value = event.target.value;
      // console.log("value",value)
      this.cityData = this.tempCityData.filter((option :any)=> option.city_name.toLowerCase().includes(value.toLowerCase()));
      this.showOptions = !!value;
    }
  
    selectOptionCity(data: any) {
      // console.log("data",data)
      this.searchTerm = data.city_name;
      this.searchCityId = data.id
      this.showOptions = false;
    }
     async getData() {
    const res = await this.apiService.POST_apiRequest(configuration.ENDPOINT.GET_DEVELOPER, {});
    if (res && !res.error && res.data) {
      this.developerData = res.data; // Assuming res.data is an array of developers
    }

    const resData = await this.apiService.POST_apiRequest(configuration.ENDPOINT.GET_REVIEWS, {});
    if (resData && !resData.error && resData.data) {
      this.reviewData = resData.data; // Assuming res.data is an array of developers
    }
  }
  

}
